import { LotusMark } from "./Brand";

const WORDS = [
  ["Pele lisa", true],
  ["REDUÇÃO PROGRESSIVA", false],
  ["mais liberdade", true],
  ["LASER DAY", false],
  ["confiança", true],
  ["MENOS IRRITAÇÕES", false],
];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
    {WORDS.map(([w, script]) => (
      <span key={w} className="flex items-center">
        <span className={script ? "font-script px-8 text-6xl text-[#E9B3A0] sm:text-7xl" : "font-display px-8 text-4xl tracking-tight text-[#FAF5EE] sm:text-5xl"}>
          {w}
        </span>
        <LotusMark className="h-7 w-7 opacity-80" id={`lm-${w.replace(/\s/g, "")}-${hidden ? 1 : 0}`} />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section aria-label="Destaques do Laser Day" className="relative overflow-hidden bg-[#2D1C18] py-8 sm:py-10" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
